/**
 * Agence'O - Carenews
 * @author Adrien Crivellaro (Agence'O)
 * @created 06/03/2021
 */
(function ($) {

  $( document ).ready(function() {

    // On load  : acutalisation

    if ( $( "#bookmark-action" ).length ) {
      $.ajax({
        url: "/bookmark/is_flagged/" + $("#bookmark-action").data('nid'),
        context: document.body
      }).done(function( response ) {

        let data = jQuery.parseJSON(response);

        if(!data.is_logged)
        {
        }
        else
        {
          if(data.error)
          {
            console.log('erreur de flag');
            return;
          }
          if(data.is_flagged)
          {
            $('#bookmark-action').text('Retirer de mes favoris');
          }
          else
          {
            $('#bookmark-action').text('Ajouter à mes favoris');
          }
        }
      });

    }


    $("#bookmark-action").bind("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      $.ajax({
        url: "/bookmark/toogle/" + $("#bookmark-action").data('nid'),
        context: document.body
      }).done(function( response ) {

        let data = jQuery.parseJSON(response);

        if(!data.is_logged)
        {
          $('#connection-required').modal('show');
        }
        else
        {

          if(data.error)
          {
            console.log('erreur de flag');
            return;
          }
          if(data.is_flagged)
          {
            $('#bookmark-action').text('Retirer de mes favoris');
          }
          else
          {
            $('#bookmark-action').text('Ajouter à mes favoris');
          }
        }
      });
    });



  });

}(jQuery));
